// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1s_v0","choiceBoxes":"toolbarselects_choiceBoxes__2DvOP","simpleField":"toolbarselects_simpleField__1JmDX"};